import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon, CheckCircle2Icon, HomeIcon, MessageCircleIcon } from 'lucide-react';
import { ThankYouConfig } from '../../types';
import { Button } from '../ui/Button';
import { BrandLogo } from '../shared/BrandLogo';
import { VideoReplay } from './VideoReplay';
interface ThankYouViewProps {
  config: ThankYouConfig;
  logoUrl?: string;
  primaryColor?: string;
  /** En la vista previa del constructor los botones no navegan. */
  preview?: boolean;
}

/**
 * Página de agradecimiento. Se usa tal cual en la ruta pública /gracias/:slug
 * y también dentro de la vista previa del constructor, para que lo que se
 * edita sea exactamente lo que verá el visitante.
 */
export function ThankYouView({
  config,
  logoUrl,
  primaryColor,
  preview = false
}: ThankYouViewProps) {
  return <main className="flex min-h-screen w-full items-center justify-center bg-surface px-5 py-16" style={primaryColor ? {
    '--primary': primaryColor
  } as React.CSSProperties : undefined} data-id="element-692" data-mp="1txfo2fvcffi2">
      <div className="w-full max-w-2xl rounded-2xl border border-border bg-background p-7 text-center shadow-soft sm:p-12" data-id="element-693" data-mp="gufn3ow2tqvd">
        <div className="mb-8 flex justify-center" data-id="element-694" data-mp="2tv52uxzjz2x">
          <BrandLogo src={logoUrl} size={28} data-id="element-695" data-mp="2xaizufxb22r" />
        </div>
        <span className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10" data-id="element-696" data-mp="7spuwgudenwj">
          <CheckCircle2Icon className="h-7 w-7 text-primary" aria-hidden="true" data-id="element-697" data-mp="3p8xy9zhbdmj7" />
        </span>
        <h1 className="text-2xl font-bold tracking-tight text-navy sm:text-3xl" data-id="element-698" data-mp="3u2sgszl6nvgp">
          {config.title}
        </h1>
        {config.subtitle && <p className="mx-auto mt-3 max-w-md text-base font-medium text-foreground" data-id="element-699" data-mp="3l8nt2p1cj05e">
            {config.subtitle}
          </p>}
        <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-muted-foreground" data-id="element-700" data-mp="36cy90wfq0x3b">
          {config.text}
        </p>

        {config.showVideo && <div className="mt-9" data-id="element-701" data-mp="2s6mruykb92lq">
            <VideoReplay url={config.videoUrl} thumbnailUrl={config.videoThumbnailUrl} maxWidthClass="max-w-xl" data-id="element-702" data-mp="2s6wfwglsozos" />
          </div>}

        {config.imageUrl && <img src={config.imageUrl} alt="" className="mx-auto mt-8 w-full rounded-xl object-cover" data-id="element-703" data-mp="2ie7b24kr2k2f" />}

        <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:justify-center" data-id="element-704" data-mp="3b3xoscigzjy0">
          {config.showCalendly && <Button leftIcon={<CalendarDaysIcon className="h-4 w-4" data-id="element-706" data-mp="3641n4jx8w4lm" />} onClick={() => {
          if (preview || !config.calendlyUrl) return;
          window.open(config.calendlyUrl, '_blank', 'noopener');
        }} data-id="element-705" data-mp="366fd4ed2iqmb">
              Agendar una llamada
            </Button>}
          {config.showWhatsapp && <Button variant="secondary" leftIcon={<MessageCircleIcon className="h-4 w-4" data-id="element-708" data-mp="asbv3csws14" />} onClick={() => {
          if (preview) return;
          const number = (config.whatsappNumber || '').replace(/\D/g, '');
          if (number) window.open(`https://wa.me/${number}`, '_blank', 'noopener');
        }} data-id="element-707" data-mp="1krhyj0sf8p2b">
              Hablar por WhatsApp
            </Button>}
          {config.showHome && (preview ? <Button variant="ghost" leftIcon={<HomeIcon className="h-4 w-4" data-id="element-710" data-mp="k0uaosoyji8m" />} data-id="element-709" data-mp="jxyep9wo73mt">
                Volver al inicio
              </Button> : <Link to="/" data-id="element-711" data-mp="szfu0q2971ag">
                <Button variant="ghost" leftIcon={<HomeIcon className="h-4 w-4" data-id="element-713" data-mp="sx3bobsl2owv" />} data-id="element-712" data-mp="t07lbooticux">
                  Volver al inicio
                </Button>
              </Link>)}
        </div>
      </div>
    </main>;
}